/* RESPONSIBLE TEAM: team-standalone */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import { get } from '@ember/object';
import type Model from '@ember-data/model';
import type Store from '@ember-data/store';
import type AppService from 'embercom/services/app-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import {
  getValidatedPlatform,
  isFieldUnavailableInProduction,
} from 'embercom/validators/standalone/field-availability-utils';

export default class FieldAvailableInProduction extends BaseValidator {
  @service declare appService: AppService;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;
  @service declare store: Store;

  validate(
    _value: unknown,
    options: { messageKey: string; attributeIdentifierPath: string },
    model: Model,
  ) {
    let identifier = get(model, options.attributeIdentifierPath) as string | undefined;
    if (!identifier) {
      return true;
    }

    let platform = getValidatedPlatform(this.appService, this.finStandaloneService);
    if (!platform) {
      return true;
    }

    if (isFieldUnavailableInProduction(identifier, platform, this.store)) {
      return this.intl.t(options.messageKey);
    }

    return true;
  }

  static getDependentsFor() {
    return [];
  }
}
